import * as React from 'react';
import { Label, Button, Input, Table, Toast, ToastHeader, ToastBody, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Card, CardTitle } from 'reactstrap';
import { Afr, Fact, unassignedFactValue, removeUnassignedFact, getSelectedAfr, ValidationError } from '../../redux/AfrSlice';
import { Concept, loadConcept, getAccountId } from '../../redux/ConceptSlice';
import { useAppSelector, useAppDispatch } from '../../hooks/index';
import { setIsDirty, isAdmin } from '../../redux/MiscSlice';
import utilityHelper from '../../utils/utilityHelper';
import enums from '../../utils/enums';
import { MessageEvent, ActionRequest, AccountWithCode, BypassStatus, getMessages, requestBypass } from '../../redux/EventsSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';


const ErrorFactList = (props: { afrId: string, bypassList: BypassStatus[], listName: string, factList: Array<Fact> }) => {
    const dispatch = useAppDispatch();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);


    function getDisplayDimensions(f: Fact) {
        var dimValues : string[] = [];
        for (var dr of f.dimensions) {
            if (dr.axis.typedDomain) {
                if (dr.typedContent && dr.typedContent.length > 0) {
                    dimValues.push(dr.axis.name + "=>" + dr.typedContent);
                } else {
                    dimValues.push(dr.axis.name + " has an EMPTY " + dr.axis.typedDomain.datatype);                    
                }
            } else {
                dimValues.push(dr.axis.name + "=>" + (dr.member != null ? dr.member.name : ""));
            }
        }
        return dimValues;
    }

    function handleAccountClick(event: any) {
        dispatch(loadConcept({
            conceptId: event.target.name,
            taxonomyType: currentAfr ? currentAfr.taxonomyType : TaxonomyTypeEnum.AFR,
            afrYear: 2022
        }));
    }
    function isDigitsOnly(str: string): boolean {
        return /^\d+$/.test(str.replace("-","").replace(".",""));
    }
    function formatFactValue(f: Fact) {
        if (f.concept) {
            if (f.textValue && f.textValue.length > 0) {
                if (!f.value || !isDigitsOnly(f.textValue)) {
                    return f.textValue.replace("uas-repunit_","").replace(/_/g," ");
                }
            }
            return utilityHelper.Formatter(f.value + "", "XBRLI_MONETARYITEMTYPE");
        }
        return f.value + "";
    }
    function isInvalidValue(f: Fact): boolean {
        if (!f.validationerrors || f.validationerrors.length == 0) {
            return false;
        }
        var result: boolean = false;
        f.validationerrors.map(e => (e.category === "INVALID_VALUE") ? result = true : false);
        return result;
    }
    function isInvalidState(f: Fact): boolean {
        if (!f.validationerrors || f.validationerrors.length == 0) {
            return false;
        }
        var result: boolean = false;
        f.validationerrors.map(e => (e.category === "INVALID_DIMENSION") ? result = true : false);
        return result;
    }
    function isDeprecated(f: Fact): boolean {
        if (!f.validationerrors || f.validationerrors.length == 0) {
            return false;
        }
        var result: boolean = false;
        f.validationerrors.map(e => (e.message.indexOf("deprecated") >= 0) ? result = true : false);
        return result;
    }
    function isMissingFact(f: Fact): boolean {
        if (f.validationerrors && f.validationerrors.length > 0) {
            var result: boolean = false;
            f.validationerrors.map(e => (e.category === enums.validationErrorCategory.missingFact) ? result = true : false);
            if (result) {
                return true;
            }
        }
        if (f.value && f.value === 999999999999) {
            return true;
        }
        if (f.concept.id === "AFRND_NoData") {
            return true;
        }
        if (f.concept.id === "BalanceSheetTitle") {
            return true;
        }
        return false;
    }
    function getMissingFactMessage(f: Fact): string {
        if (f.concept.id === "AFRND_NoData") {
            return "Missing no-data choice";
        }
        return "Missing fact(s)"
    }

    function getBypassStatusMessage(f: Fact): string {
        if (!currentAfr) {
            return "";
        }
        if (currentAfr.afrId.indexOf("AFR") < 0) {
            return "";
        }
        var bps: BypassStatus | undefined = props.bypassList.find(bp => bp.account.account === f.accountCode);
        if (bps == null) {
            return "No Status";
        }
        return utilityHelper.toTitleCase(bps.status);
    }

    function hasBypassStatus(f: Fact): boolean {
        if (!currentAfr) {
            return true;
        }
        if (currentAfr.afrId.indexOf("AFR") < 0) {
            return true;
        }
        var bps: BypassStatus | undefined = props.bypassList.find(bp => bp.account.account === f.accountCode);
        if (bps == null) {
            return false;
        }
        return true;
    }

    function handleRemoveFactClick(event: any) {
        const payload: unassignedFactValue = {
            accountCode: event.target.name,
            dimensionalSignature: "",
            concept: "",
            value: ""
        };
        dispatch(removeUnassignedFact(payload));
        // Set the information as dirty
        dispatch(setIsDirty({ IsDirty: true, Page: "" }))
    }

    function handleBypassAccountClick(event: any) {
        var args: ActionRequest = {
            actionCode: event.target.getAttribute("name"),
            connector: props.afrId
        }
        dispatch(requestBypass(args));
    }
    const getSeverityIconClass = function (err : ValidationError) : string {
        var info = "bi bi-info-circle-fill text-warning";
        var error = "bi bi-exclamation-triangle-fill text-danger";
        var warning = "bi bi-exclamation-circle-fill text-warning";
        if (!err) {
            return error;
        }
        switch (err.severity) {
            case "ERROR":
                return error;

            case "WARNING":
                return warning;

            case "INFO":
                return info;

            default:
                return error;
        }
    }

    return (
        <React.Fragment>
            <Toast className="auditDetail">
                <ToastHeader className="auditDetail">{props.listName}</ToastHeader>
                <ToastBody>
                    <div className="scrollable-table" style={{ height: "30em" }}>
                        <Table className="table" >
                            <thead className="scrollable-table-header thead-dark">
                                <tr>
                                    <th style={{ width: "5%" }}>  </th>
                                    <th>Account</th>
                                    <th>Dimensions</th>
                                    <th>Value</th>
                                    <th>Messages</th>
                                </tr>
                            </thead>

                            <tbody>
                                {props.factList.map((f: Fact, idx) => (
                                    <tr key={"factlist" + idx}>
                                        <td style={{ width: "5%" }}>
                                            {isDeprecated(f)
                                                ?
                                                    <Label><h6>Deprecated</h6></Label>
                                                :
                                                <div>
                                                    {isMissingFact(f)
                                                        ?
                                                        <Label><h6>{getMissingFactMessage(f)}</h6></Label>
                                                        :
                                                        <div>
                                                            {isInvalidState(f)
                                                                ?
                                                                <Label><h6>Invalid State</h6></Label>
                                                                :
                                                                <div>
                                                                    {isInvalidValue(f)
                                                                        ?
                                                                        <Label><h6>Invalid Value</h6></Label>
                                                                        :
                                                                        <div>
                                                                            {hasBypassStatus(f)
                                                                                ?
                                                                                <Label><h6>{getBypassStatusMessage(f)}</h6></Label>
                                                                                :
                                                                                <Button onClick={handleBypassAccountClick} name={f.accountCode}>Bypass</Button>
                                                                            }
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            }
                                        </td>
                                        <td><Button onClick={handleAccountClick} name={f.concept.id}>{f.accountCode.length === 0 ? f.concept.id : f.accountCode}</Button></td>
                                        <td style={{ width: "20%" }}><ul>
                                            {getDisplayDimensions(f).map((dref, idx) => (<li key={utilityHelper.generateGuid()}>{dref}</li>))}
                                        </ul>
                                        </td>
                                        <td style={{textAlign: 'right'}}>{formatFactValue(f)}</td>
                                        <td>{f.validationerrors ?
                                            <ul>
                                                {f.validationerrors.map((err, idx) => (<li key={utilityHelper.generateGuid()}><i className={getSeverityIconClass(err)}></i>{err.message}</li>))}
                                            </ul>
                                            : ""}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </div>
                </ToastBody>

            </Toast>
        </React.Fragment>
    );
}

export default ErrorFactList;